// extracted by mini-css-extract-plugin
module.exports = {"menuWrap":"locationDepth3_menuWrap__2K3lz","screenPage":"locationDepth3_screenPage__2FpeT"};